import { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopHeader from './TopHeader';

interface AdminLayoutProps {
  auth: {
    isAuthenticated: boolean;
    user: { name: string } | null;
    logout: () => void;
  };
}

export default function AdminLayout({ auth }: AdminLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="admin-layout">
      <Sidebar collapsed={collapsed} />
      <div className={`admin-main${collapsed ? ' sidebar-collapsed' : ''}`}>
        <TopHeader
          collapsed={collapsed}
          onToggle={() => setCollapsed((c) => !c)}
          user={auth.user}
          onLogout={auth.logout}
        />
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
